import { Search } from './control/search';
import { Layers } from './control/layers';

const search = (emptyText, geocoder) => new Search({
	emptyText: emptyText,
	geocoder: geocoder
});

const layers = (emptyText, geocoder) => new Layers();


const control_types = {
	Search, search,
	Layers, layers
}

export {
	control_types
}